import { Loader } from '../../../_shared/Loader'

export function CarParkOverviewCard({
  title,
  amount,
  rest,
  setCarList,
  isActive,
  infoText,
  description,
  hint,
  isLoading,
}: {
  title: string
  amount: number
  isActive?: boolean
  rest?: number
  setCarList?: () => void
  infoText?: string
  description?: string
  hint?: string
  isLoading?: boolean
}) {
  // ${ isActive && 'bg-slate-100 shadow-md'}
  return (
    <button
      type="button"
      onClick={setCarList}
      disabled={isLoading}
      className={`min-w-0 h-full hover:bg-slate-100 bg-white hover:shadow-md transition-all text-left popUpFromBottom p-4 border-[1px] border-[#B8C4E0] rounded-lg flex flex-col justify-between gap-4 disabled:cursor-default disabled:hover:bg-white disabled:hover:shadow-none ${
        isActive ? '!bg-slate-100' : ''
      }`}
    >
      <div className="flex flex-col gap-1">
        <p className="opacity-75">Bilpark</p>
        <p className="font-bold">{title}</p>
        <p className="text-xs opacity-75 italic leading-tight min-h-[16px] mt-1">{infoText || '\u00A0'}</p>
        <p className="text-xs text-gray-1000 mt-1">{description || '\u00A0'}</p>
        {hint && <p className="text-xs opacity-75 leading-tight mt-1">{hint}</p>}
      </div>
      <div className="flex items-end flex-row gap-2 min-h-[40px]">
        {isLoading ? (
          <div className="flex items-center h-10">
            <Loader />
          </div>
        ) : (
          <>
            <p className="text-2xl sm:text-3xl xl:text-4xl text-[#07168B]">{amount}</p>
            {rest && <span className=""> / {rest}</span>}
          </>
        )}
      </div>
    </button>
  )
}
